import { gql } from 'graphql-request';

export const CACHE_INVOICE_CHANGE_CURRENCY_QUERY = gql`
  mutation CacheInvoiceChangeCurrency(
    $uuid: ID!
    $currencyRateId: ID
    $selectedCurrency: String
  ) {
    invoiceChangeCurrency(
      input: {
        uuid: $uuid
        currencyRateId: $currencyRateId
        selectedCurrency: $selectedCurrency
      }
    ) {
      appVersion
      errors {
        fullMessages
      }
      record {
        id
        nanoId
        uuid
      }
      recordId
      recordNanoId
      recordUuid
      status
    }
  }
`;
